// Generated from line_plot_settings.v1.json
// DO NOT EDIT MANUALLY

import {z} from 'zod';


export const linePlotTemplateSettingsSchema = z.object({
"groupAgg": z.enum(["last",
"max",
"mean",
"median",
"min",
"samples",
"sum"]).describe("Aggregation method for grouped runs").optional(),
"maxRuns": z.number().int().gte(1).describe("Maximum number of runs to display").optional(),
"smoothingWeight": z.number().describe("Weight for smoothing algorithm").optional(),
"smoothingType": z.enum(["average",
"exponential",
"exponentialTimeWeighted",
"gaussian",
"none"]).describe("Type of smoothing to apply").optional(),
"useRunsTableGroupingInPanels": z.boolean().describe("Whether to use runs table grouping in panels").optional(),
"xAxis": z.string().describe("The metric or dimension to plot on X axis (e.g. '_step', '_runtime', '_timestamp', '_absolute_runtime', or custom metric)").optional(),
"xLogScale": z.boolean().describe("Whether to use logarithmic scale on X axis").optional(),
"xAxisMin": z.number().describe("Minimum value for X axis").optional(),
"xAxisMax": z.number().describe("Maximum value for X axis").optional(),
"xAxisFormat": z.enum(["number",
"datetime"]).describe("Format for X axis values (i.e. 'number' or 'datetime')").optional(),
"yLogScale": z.boolean().describe("Whether to use logarithmic scale on Y axis").optional(),
"yAxisMin": z.number().describe("Minimum value for Y axis").optional(),
"yAxisMax": z.number().describe("Maximum value for Y axis").optional()
}).strict().describe("Subset of line plot settings that are saved in workspace templates")


export type LinePlotSettingsV1 = z.infer<typeof linePlotTemplateSettingsSchema>;
